import * as z from "zod";

export const checkSession = {
  name: "checkSession" as const,
  input: z.object({}),
  output: z.object({ version: z.number().nullable() }),
};
